<template>
  <path
    fill="none"
    stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="1"
    d="M9.53516 2.46484L2.46409 9.53591"
  />
  <circle
    fill="none"
    stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="1"
    cx="3.17218"
    cy="3.17188"
    r="1.5"
  />
  <circle
    fill="none"
    stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="1"
    cx="8.82843"
    cy="8.82812"
    r="1.5"
  />
</template>
